import microdoseAvatar from "@/assets/images/microdoseAvatar.png";

const MicrodoseDisclaimer = () => (
  <div className="pt-4 w-full">
    <div className="flex w-full items-start gap-2 rounded-2xl border border-[rgba(31,31,31,0.08)] bg-[#f7f7ff] p-3 font-sofia drop-shadow-[0px_16px_16px_rgba(0,0,0,0.04)]">
      <div className="relative size-11 shrink-0 overflow-hidden rounded-full bg-[rgba(79,65,166,0.2)]">
        <img
          src={microdoseAvatar}
          alt=""
          className="absolute left-[calc(50%+0.5px)] top-[calc(50%+13.7px)] size-[71px] max-w-none -translate-x-1/2 -translate-y-1/2 object-cover"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col justify-center gap-1">
        <p className="text-base font-medium leading-normal tracking-[-0.64px] text-[#1f1f1f]">
          You’re eligible for our microdose option
        </p>
        <p className="text-xs leading-[14px] tracking-[-0.48px] text-[rgba(31,31,31,0.64)]">
          Based on your BMI, our provider may consider a lower-dose treatment
          option tailored to your profile.
        </p>
      </div>
    </div>
  </div>
);

export { MicrodoseDisclaimer };
